import { render, staticRenderFns } from "./myjdpid.vue?vue&type=template&id=2fe836ac&scoped=true"
import script from "./myjdpid.vue?vue&type=script&lang=js"
export * from "./myjdpid.vue?vue&type=script&lang=js"
import style0 from "./myjdpid.vue?vue&type=style&index=0&id=2fe836ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe836ac",
  null
  
)

export default component.exports